import {Title} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {providePrimeNG} from 'primeng/config';

import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {UrlHandlingStrategy} from '@angular/router';
import {registerLocaleData} from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {MenuComponent} from './main-temp/menu/menu.component';
import {MainTempComponent} from './main-temp/main-temp.component';
import {HomeComponent} from './home/home.component';
import {SubMenuComponent} from './main-temp/menu/sub-menu/sub-menu.component';
import {DevInterceptor} from './shared/http.interceptor';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import localeRu from '@angular/common/locales/ru';
import {SharedModule} from './shared/shared.module';
import {OverlayModule} from '@angular/cdk/overlay';
import {A11yModule} from '@angular/cdk/a11y';
import {MenuContainerComponent} from './main-temp/menu/menu-container/menu-container.component';
import {MenuService} from './main-temp/menu/menu.service';
import {RouterStateSpinnerService} from './shared/header/router-state-spinner/router-state-spinner.service';
import {RouterStateSpinnerComponent} from './shared/header/router-state-spinner/router-state-spinner.component';
import {MainContentWrapperComponent} from './main-temp/main-content-wrapper/main-content-wrapper.component';
import {UserStatusResolverService} from './shared/resolvers/user-status-resolver.service';
import {AuthenticationApiService} from '../../projects/api/src/authentication/authentication-api.service';
import {ContactApiService} from '../../projects/api/src/contact/contact-api.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {SemRestRequestService} from '../../projects/api/src/sem-rest-request/sem-rest-request.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {ObjectsService} from './shared/services/objects.service';
import {environment} from '../environments/environment';
import {DashboardApiService} from '../../projects/api/src/dashboard/dashboard-api.service';
import {ObjrubricApiService} from '../../projects/api/src/objrubric/objrubric-api.service';

import {EventsApiService} from '../../projects/api/src/event/events-api.service';
import {CommandApiService} from '../../projects/api/src/command/command-api.service';
import {ObjectApiService} from '../../projects/api/src/object/object-api.service';

import {NotFoundComponent} from './main-temp/not-found/not-found.component';
import {NotFoundModule} from './main-temp/not-found/not-found.module';
import {ConfirmationService, MessageService} from 'primeng/api';
import {UnitsApiService} from '../../projects/api/src/unit/units-api.service';
import {ToastModule} from 'primeng/toast';
import {InsparkComponentsModule, InsparkMessageService} from '@inspark/inspark-components';
import {ObjectSchedulerModule} from './object-scheduler/object-scheduler.module';
import {LocalStorageService} from '../../projects/api/src/locale-storage/locale-storage.service';
import {BrandingApiService} from '../../projects/api/src/branding/branding-api.service';
import {UsersubscriptionsApiService} from '../../projects/api/src/usersubscription/usersubscriptions-api.service';
import {NgxEchartsModule} from 'ngx-echarts';
import {SupersetApiService} from '../../projects/api/src/superset/superset.service';
import {ConfigApiService} from '../../projects/api/src/config/config-api.service';
import {SystemEventsApiService} from '../../projects/api/src/system-service/system-events-api.service';
import {ConfigureModule} from '../../projects/common/modules/configure/configure.module';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ComponentsModule} from './components/inspark.module';
import {ToastrModule} from 'ngx-toastr';
import {createMenu} from './main-temp/menu/menu';
import {DataStorageService} from '../../projects/api/src/locale-storage/data-storage.service';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {NgxSliderModule} from "@angular-slider/ngx-slider";

export class Ng1Ng2UrlHandlingStrategy implements UrlHandlingStrategy {
  shouldProcessUrl(url) {
    console.log('Should process called for: ' + url);
    // return !url.toString().startsWith('/app');
    return true;
  }

  extract(url) {
    return url;
  }

  merge(url, whole) {
    return url;
  }
}

registerLocaleData(localeRu, 'ru');


@NgModule({ declarations: [
        AppComponent,
        // TestComponent,
        MenuComponent,
        MainTempComponent,
        HomeComponent,
        SubMenuComponent,
        RouterStateSpinnerComponent,
        MenuContainerComponent,
    ],
    exports: [
        TranslateModule,
        MainContentWrapperComponent,
        ComponentsModule,
        InsparkComponentsModule,
        NotFoundComponent,
        ObjectSchedulerModule,
    ],
    bootstrap: [AppComponent], imports: [SharedModule.forRoot(),
        // NgSelectModule,
        PopoverModule,
        FormsModule,
        InsparkComponentsModule,
        ToastModule,
        BrowserAnimationsModule,
        ConfirmDialogModule,
        NgbModule,
        // UpgradeModule,
        AppRoutingModule,
        NgxSliderModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        OverlayModule,
        A11yModule,
        NotFoundModule,
        ObjectSchedulerModule,
        NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
        ConfigureModule.forRoot({
            appCode: 'semux',
            appName: 'semux',
            eventsLog: { objects: true, units: true, places: false },
            appConfig: {
                typeOfDefaultUrl: 'dynamic',
            },
            charts: { groupBy: 'controller',
                parameters: true,
                objects: true,
                events: true,
                dashboards: true }
        }),
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: false
        })], providers: [
        Title,
        RouterStateSpinnerService,
        DashboardApiService,
        ObjrubricApiService,
        UnitsApiService,
        UsersubscriptionsApiService,
        EventsApiService,
        SystemEventsApiService,
        ObjectApiService,
        CommandApiService,
        InsparkMessageService,
        ConfirmationService,
        ObjectsService,
        { provide: 'API_URL', useValue: environment.backEndUrlPrefix },
        { provide: 'FILE_URL', useValue: environment.fileServer },
        { provide: 'CREATE_MENU', useValue: createMenu },
        MessageService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DevInterceptor,
            multi: true
        },
        {
            provide: UrlHandlingStrategy,
            useClass: Ng1Ng2UrlHandlingStrategy,
        },
        MenuService,
        ConfigApiService,
        UserStatusResolverService,
        AuthenticationApiService,
        ContactApiService,
        BrandingApiService,
        DeviceDetectorService,
        SemRestRequestService,
        LocalStorageService,
        DataStorageService,
        SupersetApiService,
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({ theme: 'none' }),
    ] })
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
